module.exports.baseUrl = 'img/';
module.exports.manifest = [
    {name: '0', url: 'include/boss_page_logo.png'},
    {name: '1', url: 'include/hummels_boss_intro.png'},
    {name: '2', url: 'include/hummels/bg.jpg'},
    {name: '3', url: 'include/hummels/bg1.jpg'},
    {name: '4', url: 'include/hummels/bg2.jpg'},
    {name: '5', url: 'include/hummels/bg3.jpg'},
    {name: '6', url: 'include/hummels/bg4.jpg'},
    {name: '7', url: 'include/hummels/img1.jpg'},
    {name: '8', url: 'include/hummels/img2.jpg'},
    {name: '9', url: 'include/hummels/img3.jpg'},
    {name: '10', url: 'include/hummels/img4.jpg'},
    {name: '11', url: 'include/hummels/img5.jpg'},
    {name: '12', url: 'include/mario/bg1.jpg'},
    {name: '13', url: 'include/mario/bg2_1.jpg'},
    {name: '14', url: 'include/mario/bg2_2.jpg'},
    {name: '15', url: 'include/mario/img1.jpg'},
    {name: '16', url: 'include/mario/img2.jpg'},
    {name: '17', url: 'include/mario/img3.jpg'},
    {name: '18', url: 'include/mario/img4.jpg'},
    {name: '19', url: 'include/mario/imgbg1.jpg'},
    {name: '20', url: 'include/toni/bg1.jpg'},
    {name: '21', url: 'include/toni/bg2.jpg'},
    {name: '22', url: 'include/toni/img1.jpg'},
    {name: '23', url: 'include/toni/img2.jpg'},
    {name: '24', url: 'include/toni/img3.jpg'},
    {name: '25', url: 'include/toni/img4.jpg'},
    {name: '26', url: 'include/toni/img5.jpg'},
    {name: '27', url: 'include/toni/imgbg1.jpg'},
    {name: '28', url: 'include/toni/imgbg2.jpg'},
    {name: 'teamForCover', url: 'include/teamForCover.jpg'},
    {name: 'hummelsCover', url: 'include/hummels/hummels_cover.jpg'},
    {name: 'bossMsk', url: 'include/boss.svg'}
    ];
module.exports.mobileManifest = [
    {name: '1', url: 'include/boss_page_logo.png'},
    {name: '2', url: 'include/hummels_boss_intro.png'},
    {name: '3', url: 'include/hummels/01.jpg'},
    {name: '4', url: 'include/hummels/02.jpg'},
    {name: '5', url: 'include/hummels/03.jpg'},
    {name: '6', url: 'include/hummels/04.jpg'},
    {name: '7', url: 'include/hummels/05.jpg'},
    {name: '8', url: 'include/mario/01.jpg'},
    {name: '9', url: 'include/mario/02.jpg'},
    {name: '10', url: 'include/mario/03.jpg'},
    {name: '11', url: 'include/toni/01.jpg'},
    {name: '12', url: 'include/toni/02.jpg'},
    {name: '13', url: 'include/toni/03.jpg'},
    {name: '14', url: 'include/toni/04.jpg'},
    {name: 'teamForCover', url: 'include/teamForCover.jpg'},
    {name: 'hummelsCover', url: 'include/hummels/hummels_cover.jpg'},
    {name: 'bossMsk', url: 'include/boss.svg'}
    ];


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/load/Manifest.js